// renderPolicy.js — CHAT-3 render-policy decision (pure, zero-dependency, node-testable).
//
// WHY IT IS PURE (NO IMPORTS): like assistantBlocks.js, this module is tested via
// `node --test` in bare-node ESM. It carries NO React / react-markdown import so the
// SETTLED-ASSISTANT-ONLY markdown policy is verifiable without a webpack build step.
//
// THE POLICY (the safety boundary CHAT-3 locks):
//   Markdown-render a turn ONLY when it is a SETTLED assistant turn.
//   - role:'user' turns           → NEVER markdown (the user typed literal text; a stray
//                                    `**` in their message must not become bold).
//   - LIVE typewriter deltas      → NEVER markdown (mid-stream partial markdown like a lone
//                                    `**` with no closing `**` would flash half-rendered).
//   - settled role:'assistant'    → markdown-render (the line-439 branch in AgentStudioChat).
//
// A "live" turn is one flagged { live:true } (the ephemeral delta path); the durable,
// reconciled assistant turn has no live flag. Anything without role:'assistant' is plain.
//
// EXPORTED API
//   shouldMarkdownRender(turn) → boolean

/**
 * Decide whether a conversation turn should be rendered through the markdown renderer.
 * @param {{role?: string, live?: boolean}} turn
 * @returns {boolean} true ONLY for settled (non-live) assistant turns.
 */
export function shouldMarkdownRender(turn) {
  if (!turn || typeof turn !== "object") return false
  // Live typewriter deltas stay plain text — no mid-stream partial-markdown flash.
  if (turn.live === true) return false
  // Only the assistant's settled prose is markdown. User text renders literally.
  return turn.role === "assistant"
}
